import { Link } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import Select from "react-select";
import {
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../common/Constant";
import { toastError, toastSuccess } from "../../common/Toast";
import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const ApproveConfirmation = ({ upsertApiUrl, open, onClose }) => {
  const [roletierdropdown, setRoleTierDropDown] = useState([]);
  const [ecomuser, setecomuser] = useState([]);
  const [taxvalue, setTaxValue] = useState(0);
  const [companyname, setCompanyName] = useState("");
  const userid = localStorage.getItem("userid");

  const token = localStorage.getItem("Token");

  console.log(ecomuser, "ecomuser");
  useEffect(() => {
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/Roletierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => setRoleTierDropDown(res.data.ResponseData))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    axios
      .get(
        `${config.customersBaseUrl}/customers/Ecomuserfindbyid?ID=${userid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => setecomuser(res.data.ResponseData.CustomerDetails[0]))
      .catch((error) => console.log(error));
  }, [open]);

  let RoleTierDropdownOption = [];
  const RolesTierDropdown = roletierdropdown.map((u, i) => {
    RoleTierDropdownOption[i] = { label: u.Name, value: u.ID };
  });

  function handleApprovePopup() {
    const data = {
      userid: localStorage.getItem("userid"),
      loginid: localStorage.getItem("ID"),
      roletierid: taxvalue ? taxvalue : ecomuser?.RoleId,
      companyname: companyname ? companyname : ecomuser?.CompanyName,
      ecomsdata: ecomuser,
    };

    // return
    axios
      .post(`${upsertApiUrl}`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          // setLoading(false);
          window.location.reload();
          // navigate("/edit-profile");
        } else if (res.data.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
          // setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleRoleGroup = (e) => {
    setTaxValue(e?.value);
  };

  const handleChange = (e) => {
    setCompanyName(e?.target.value);
  };

  return (
    <>
      <div
        className="modal fade"
        id={"ApproveConfirmationModal"}
        tabIndex={-1}
        aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmation</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6>Are you sure you want to make this user as customer?</h6>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <label className="col-md-4">Role Tier :</label>

                    <div className="col-md-8">
                      <Select
                        // defaultValue={quickBookOptions}
                        value={RoleTierDropdownOption.find(
                          (option) => option.value == taxvalue
                        )}
                        onChange={(event) => {
                          handleRoleGroup(event);
                        }}
                        options={RoleTierDropdownOption}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        isClearable={true}
                        // hideSelectedOptions={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        className="custom-search-select"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <div className="row">
                    <label className="col-md-4">Company Name :</label>
                    <div className="col-md-8">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Enter Company Name"
                        onChange={(e) => handleChange(e)}
                        value={
                          ecomuser && ecomuser.CompanyName
                            ? ecomuser.CompanyName
                            : companyname
                        } // Assumed ecomuser is properly initialized
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => handleApprovePopup()}
              >
                Yes{" "}
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                No{" "}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* REAL PART */}
      <Dialog open={open}>
        <DialogTitle textAlign="center" className="p-lg">
          Confirmation
        </DialogTitle>
        <DialogContent>
          <div className="modal-body" style={{ width: "400px" }}>
            <div className="row">
              <div className="col-lg-12 col-form-label mb-4">
                <p className="col-form-label">
                  Are you sure you want to make this user as customer?
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12" style={{ Width: "400px" }}>
                <div className="row">
                  <label className="col-md-4 col-form-label">Role Tier :</label>

                  <div className="col-md-8">
                    <Select
                      // defaultValue={quickBookOptions}
                      value={
                        taxvalue
                          ? RoleTierDropdownOption.find(
                              (option) => option.value == taxvalue
                            )
                          : RoleTierDropdownOption.find(
                              (option) => option.value == ecomuser?.RoleId
                            )
                      }
                      onChange={(event) => {
                        handleRoleGroup(event);
                      }}
                      options={RoleTierDropdownOption}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      // hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      className="custom-search-select"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-md-12">
                <div className="row">
                  <label className="col-md-4 col-form-label">
                    Company Name :
                  </label>

                  <div className="col-md-8">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter Company Name"
                      onChange={(e) => handleChange(e)}
                      value={
                        ecomuser && ecomuser.CompanyName
                          ? ecomuser.CompanyName
                          : companyname
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button class="btn btn-sm btn-outline-dark" onClick={onClose}>
            No
          </Button>
          <Button
            class="btn btn-sm btn-primary"
            onClick={handleApprovePopup}
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ApproveConfirmation;
